import { storableError } from '../../util/errors';
import { currentUserShowSuccess } from '../../ducks/user.duck';
import {
  getFAQsApi,
  getPublicFAQsApi,
  updateFAQsApi,
  getSessionTypesApi,
  getPublicSessionTypesApi,
  getSubjectReviewsApi,
  nativeUpdateProfileApi,
  uploadProfileImageApi,
} from '../../util/api';

// ================ Action types ================ //

export const CLEAR_UPDATED_FORM = 'app/ProfileSettingsPage/CLEAR_UPDATED_FORM';

export const UPLOAD_IMAGE_REQUEST = 'app/ProfileSettingsPage/UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS = 'app/ProfileSettingsPage/UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_ERROR = 'app/ProfileSettingsPage/UPLOAD_IMAGE_ERROR';

export const UPDATE_PROFILE_REQUEST = 'app/ProfileSettingsPage/UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'app/ProfileSettingsPage/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR = 'app/ProfileSettingsPage/UPDATE_PROFILE_ERROR';

export const FETCH_REVIEWS_REQUEST = 'app/ProfileSettingsPage/FETCH_REVIEWS_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'app/ProfileSettingsPage/FETCH_REVIEWS_SUCCESS';
export const FETCH_REVIEWS_ERROR = 'app/ProfileSettingsPage/FETCH_REVIEWS_ERROR';

export const FETCH_FAQS_REQUEST = 'app/ProfileSettingsPage/FETCH_FAQS_REQUEST';
export const FETCH_FAQS_SUCCESS = 'app/ProfileSettingsPage/FETCH_FAQS_SUCCESS';
export const FETCH_FAQS_ERROR = 'app/ProfileSettingsPage/FETCH_FAQS_ERROR';

export const UPDATE_FAQS_REQUEST = 'app/ProfileSettingsPage/UPDATE_FAQS_REQUEST';
export const UPDATE_FAQS_SUCCESS = 'app/ProfileSettingsPage/UPDATE_FAQS_SUCCESS';
export const UPDATE_FAQS_ERROR = 'app/ProfileSettingsPage/UPDATE_FAQS_ERROR';

export const FETCH_SESSION_TYPES_REQUEST = 'app/ProfileSettingsPage/FETCH_SESSION_TYPES_REQUEST';
export const FETCH_SESSION_TYPES_SUCCESS = 'app/ProfileSettingsPage/FETCH_SESSION_TYPES_SUCCESS';
export const FETCH_SESSION_TYPES_ERROR = 'app/ProfileSettingsPage/FETCH_SESSION_TYPES_ERROR';

// ================ Reducer ================ //

const initialState = {
  image: null,
  uploadedImages: {},
  uploadImageError: null,
  uploadInProgress: false,
  updateInProgress: false,
  updateProfileError: null,
  reviews: [],
  fetchReviewsInProgress: false,
  fetchReviewsError: null,
  faqs: null,
  fetchFaqsInProgress: false,
  fetchFaqsError: null,
  updateFaqsInProgress: false,
  updateFaqsError: null,
  sessionTypes: [],
  fetchSessionTypesInProgress: false,
  fetchSessionTypesError: null,
};


export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPLOAD_IMAGE_REQUEST:
      // payload.params: { id: 'tempId', file }
      const requestId = payload.params.id;
      return {
        ...state,
        image: { ...payload.params },
        uploadedImages: {
          ...state.uploadedImages,
          [requestId]: { ...payload.params, uploadInProgress: true, error: null },
        },
        uploadInProgress: true,
        uploadImageError: null,
      };
    case UPLOAD_IMAGE_SUCCESS: {
      // payload: { id: 'tempId', uploadedImage }
      const { id, uploadedImage } = payload;
      const { file } = state.uploadedImages[id] || {};
      const imageData = { id, imageId: uploadedImage.id, file, uploadedImage };
      return {
        ...state,
        image: imageData,
        uploadedImages: {
          ...state.uploadedImages,
          [id]: { ...imageData, uploadInProgress: false, error: null },
        },
        uploadInProgress: false,
      };
    }
    case UPLOAD_IMAGE_ERROR: {
      const errorId = payload.id;
      return {
        ...state,
        image: null,
        uploadedImages: {
          ...state.uploadedImages,
          [errorId]: { ...state.uploadedImages[errorId], uploadInProgress: false, error: payload.error },
        },
        uploadInProgress: false,
        uploadImageError: payload.error,
      };
    }


    case UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        updateInProgress: true,
        updateProfileError: null,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        image: null,
        updateInProgress: false,
      };
    case UPDATE_PROFILE_ERROR:
      return {
        ...state,
        image: null,
        updateInProgress: false,
        updateProfileError: payload,
      };

    case FETCH_REVIEWS_REQUEST:
      return {
        ...state,
        fetchReviewsInProgress: true,
        fetchReviewsError: null,
        reviews: [],
      };
    case FETCH_REVIEWS_SUCCESS:
      return { ...state, fetchReviewsInProgress: false, reviews: payload };
    case FETCH_REVIEWS_ERROR:
      return { ...state, fetchReviewsInProgress: false, fetchReviewsError: payload };

    case FETCH_FAQS_REQUEST:
      return { ...state, fetchFaqsInProgress: true, fetchFaqsError: null };
    case FETCH_FAQS_SUCCESS:
      return { ...state, fetchFaqsInProgress: false, faqs: payload };
    case FETCH_FAQS_ERROR:
      return { ...state, fetchFaqsInProgress: false, fetchFaqsError: payload };

    case UPDATE_FAQS_REQUEST:
      return { ...state, updateFaqsInProgress: true, updateFaqsError: null };
    case UPDATE_FAQS_SUCCESS:
      return { ...state, updateFaqsInProgress: false, faqs: payload };
    case UPDATE_FAQS_ERROR:
      return { ...state, updateFaqsInProgress: false, updateFaqsError: payload };

    case FETCH_SESSION_TYPES_REQUEST:
      return { ...state, fetchSessionTypesInProgress: true, fetchSessionTypesError: null, sessionTypes: [] };
    case FETCH_SESSION_TYPES_SUCCESS:
      return { ...state, fetchSessionTypesInProgress: false, sessionTypes: payload };
    case FETCH_SESSION_TYPES_ERROR:
      return { ...state, fetchSessionTypesInProgress: false, fetchSessionTypesError: payload };

    case CLEAR_UPDATED_FORM:
      return { ...state, updateProfileError: null, uploadImageError: null };

    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const clearUpdatedForm = () => ({
  type: CLEAR_UPDATED_FORM,
});

// SDK method: images.upload
export const uploadImageRequest = params => ({ type: UPLOAD_IMAGE_REQUEST, payload: { params } });
export const uploadImageSuccess = result => ({ type: UPLOAD_IMAGE_SUCCESS, payload: result.data });
export const uploadImageError = error => ({
  type: UPLOAD_IMAGE_ERROR,
  payload: error,
  error: true,
});

// SDK method: sdk.currentUser.updateProfile
export const updateProfileRequest = params => ({
  type: UPDATE_PROFILE_REQUEST,
  payload: { params },
});
export const updateProfileSuccess = result => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: result.data,
});
export const updateProfileError = error => ({
  type: UPDATE_PROFILE_ERROR,
  payload: error,
  error: true,
});

export const fetchReviewsRequest = () => ({ type: FETCH_REVIEWS_REQUEST });
export const fetchReviewsSuccess = reviews => ({ type: FETCH_REVIEWS_SUCCESS, payload: reviews });
export const fetchReviewsError = error => ({
  type: FETCH_REVIEWS_ERROR,
  error: true,
  payload: error,
});

// ================ Thunk ================ //

// Replaces the dead sdk.images.upload call (Marketplace API credentials are
// revoked) with the native S3 endpoint already used by the coach cover-image
// flow. uploadedImage.id is set to the resulting URL -- every downstream
// consumer (ProfilePage.js, ProfileSettingsPage.js) only ever reads
// uploadedImages[id].imageId to forward it straight into the
// profileImageId field on the profile-update PATCH, so passing the URL
// through unchanged keeps that whole chain working with no further edits.
//
// It also carries an `attributes.variants` map (all pointing at the same
// S3 URL, since there's no server-side resizing) so this object matches the
// shape ResponsiveImage/Avatar expect from a real Sharetribe image entity --
// without it, ProfileSettingsForm's post-upload avatar preview renders this
// object through <Avatar>, which crashed the whole page reading
// `image.attributes.variants` off a plain `{id, url}` object. See
// ResponsiveImage.js's `image.attributes?.variants` guard for the same fix
// applied defensively for any other caller.
const AVATAR_PREVIEW_VARIANT_SIZES = {
  'square-xsmall': 40,
  'square-xsmall2x': 80,
  'square-small': 240,
  'square-small2x': 480,
};

export function uploadImage(actionPayload) {
  return (dispatch, getState, sdk) => {
    const id = actionPayload.id;
    dispatch(uploadImageRequest(actionPayload));

    return uploadProfileImageApi(actionPayload.file)
      .then(response => {
        const variants = Object.fromEntries(
          Object.entries(AVATAR_PREVIEW_VARIANT_SIZES).map(([name, size]) => [
            name,
            { url: response.imageUrl, width: size, height: size },
          ])
        );
        const uploadedImage = {
          id: response.imageUrl,
          url: response.imageUrl,
          key: response.imageKey,
          type: 'image',
          attributes: { variants },
        };
        dispatch(uploadImageSuccess({ data: { id, uploadedImage } }));
      })
      .catch(e => dispatch(uploadImageError({ id, error: storableError(e) })));
  };
}

// Phase 5 (native session): replaces the direct sdk.currentUser.updateProfile
// call. actionPayload already matches the shape PATCH /api/auth/native/profile
// expects (firstName/lastName/bio/publicData/protectedData/privateData/
// profileImageId) -- every caller of this thunk (ProfileSettingsPage.js,
// ProviderPage's ProfilePage.js, SessionTypes.js) already builds it that way.
export const updateProfile = actionPayload => {
  return (dispatch, getState, sdk) => {
    dispatch(updateProfileRequest());

    return nativeUpdateProfileApi(actionPayload)
      .then(response => {
        dispatch(updateProfileSuccess(response));

        const currentUser = response?.currentUser;
        if (!currentUser) {
          throw new Error('Expected a currentUser in the native profile-update response');
        }

        // Update current user in state.user.currentUser through user.duck.js
        dispatch(currentUserShowSuccess(currentUser));
      })
      .catch(e => dispatch(updateProfileError(storableError(e))));
  };
};

export const fetchReviewsBySubject = subjectId => dispatch => {
  const normalizedSubjectId = typeof subjectId === 'string' ? subjectId : subjectId?.uuid;
  if (!normalizedSubjectId) {
    dispatch(fetchReviewsSuccess([]));
    return Promise.resolve([]);
  }

  dispatch(fetchReviewsRequest());
  return getSubjectReviewsApi(normalizedSubjectId, { type: 'ofProvider', limit: 100 })
    .then(response => {
      const reviews = response?.items || [];
      dispatch(fetchReviewsSuccess(reviews));
      return reviews;
    })
    .catch(e => {
      dispatch(fetchReviewsError(storableError(e)));
      return [];
    });
};

export const fetchFaqs = () => (dispatch, getState, sdk) => {
  dispatch({ type: FETCH_FAQS_REQUEST });
  return getFAQsApi({})
    .then(response => {
      dispatch({ type: FETCH_FAQS_SUCCESS, payload: response.data || [] });
    })
    .catch(e => {
      dispatch({ type: FETCH_FAQS_ERROR, payload: storableError(e) });
    });
};

export const fetchPublicFaqs = userId => (dispatch, getState, sdk) => {
  dispatch({ type: FETCH_FAQS_REQUEST });
  return getPublicFAQsApi({ userId })
    .then(response => {
      dispatch({ type: FETCH_FAQS_SUCCESS, payload: response.data || [] });
    })
    .catch(e => {
      dispatch({ type: FETCH_FAQS_ERROR, payload: storableError(e) });
    });
};

export const updateFaqs = faqs => (dispatch, getState, sdk) => {
  dispatch({ type: UPDATE_FAQS_REQUEST });
  return updateFAQsApi({ faqs })
    .then(response => {
      dispatch({ type: UPDATE_FAQS_SUCCESS, payload: response.data });
      return response.data;
    })
    .catch(e => {
      dispatch({ type: UPDATE_FAQS_ERROR, payload: storableError(e) });
      throw e;
    });
};

export const fetchSessionTypesListings = (userId = null) => (dispatch, getState, sdk) => {
  dispatch({ type: FETCH_SESSION_TYPES_REQUEST });
  const apiCall = userId
    ? getPublicSessionTypesApi({ userId, includeCampSessions: true })
    : getSessionTypesApi({ includeInactive: false });
  return apiCall
    .then(response => {
      dispatch({ type: FETCH_SESSION_TYPES_SUCCESS, payload: response.data || [] });
    })
    .catch(e => {
      dispatch({ type: FETCH_SESSION_TYPES_ERROR, payload: storableError(e) });
    });
};
